import { Radio } from "lucide-react";
import { Panel, EV_STYLE, clock, evText } from "./util";

export const LiveStream = ({ events, online }) => (
  <Panel title="Live activity stream" testid="insights-live" right={<span className={`font-mono text-[10px] flex items-center gap-1.5 ${online ? "text-brand" : "text-white/40"}`}><Radio className={`w-3 h-3 ${online ? "animate-pulse" : ""}`} />{online ? "STREAMING" : "IDLE"}</span>}>
    <ul className="font-mono text-[11px] space-y-1 max-h-[520px] overflow-y-auto" data-testid="live-list">
      {!events.length && <li className="text-white/45">No activity yet.</li>}
      {events.map((e, i) => {
        const [tone, tag] = EV_STYLE[e.event] || ["text-white/50", e.event];
        return (
          <li key={i} className="flex gap-2 py-1 border-b border-white/5 animate-in fade-in duration-300" data-testid={`live-event-${i}`}>
            <span className="text-white/30 w-[68px] shrink-0">{clock(e.at)}</span>
            <span className={`${tone} w-[64px] shrink-0`}>{tag}</span>
            <span className="text-white/75 truncate">{evText(e)}</span>
          </li>
        );
      })}
    </ul>
  </Panel>
);
